import _Button from 'components/button';
import { color, media, typography } from 'styles/settings';
import styled from 'styled-components';
import BrandPattern from 'styles/icons/brand-pattern.svg';
import { normalize } from 'utils/styles';
import { ReactComponent as LogoIcon } from 'styles/icons/logo.svg';
import logo from 'styles/icons/immoOx-Text.png';
import logo1 from 'styles/icons/LogoImmo.png';

const HEADER_SIDE_PADDING_CALC = (multiplier = 1) =>
  `calc(${multiplier} * (100vw * 0.034))`;
export const Header = styled.header`
  display: flex;
  flex-direction: row;
  position: fixed;
  top: 0;
  left: 0;
  align-items: center;
  width: calc(100% - ${HEADER_SIDE_PADDING_CALC(2)});
  padding: 0 30px;
  z-index: 10;
  height: 110px;
  padding: 0 ${HEADER_SIDE_PADDING_CALC()};
`;

export const Button = styled(_Button)`
  font-size: ${typography.size.md};
`;

export const HeaderStyledLogoIcon = styled(LogoIcon)`
  position: relative;
  width: 128px;
  height: 26px;
`;
const LogoIconImmo = () => {
  return <img src={logo} alt="fireSpot" />;
};

export const HeaderStyledLogoIconImmo = styled.img.attrs(({ src }) => ({
  src: logo,
  alt: 'Article Cover',
}))`
  position: relative;
  width: 128px;
  height: 40px;
  object-fit: contain;
`;

export const HeaderStyledLogoIconImmo22 = styled(LogoIconImmo)`
  position: relative;
  width: 128px;
  height: 26px;
`;

export const HeaderInnerRight = styled.div`
  width: max-content;
  position: relative;
  margin-left: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: calc(50% - 30px);
  padding-left: 30px;
  > div {
    display: flex;
    align-items: center;
    margin-left: auto;
  }
`;

export const HeaderInnerRightLabelText = styled.span`
  color: ${color.neutral.white};
  ${typography.font.content.medium};
  font-size: ${typography.size.md};
  line-height: ${typography.size.ml};
  height: ${normalize(typography.size.ml)};
  margin-right: 30px;
  ${media.mediaQueries.mobile`
    display:none;
  `}
`;

export const Container = styled.div`
  position: relative;
  /* background-color: ${color.neutral.white}; */
  background: ${({ theme }) => theme.background};
`;

export const InnerContainer = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
  height: 100%;
`;

export const InnerLeft = styled.div`
  position: relative;
  /* width: 50%; */
  width: ${({ theme }) => (theme.name == 'cortlex' ? '50%' : '100%')};
  height: 100%;
  display: flex;
  flex-direction: column;
  transform: translateY(-50%);
  top: ${({ top }) => normalize(top)};

  ${media.mediaQueries.mobile`
  width: 100%;
  `}
`;

export const InnerLeftInner = styled.div`
  position: relative;
  width: calc(100% - 60px);
  padding: 0 30px;
  ${media.centerHorizontal}
  max-width: 560px;
`;

/**
 * Title sizes with the viewport size between `min` and `max` values
 */
const TITLE_FONT_SIZE_MAP = { min: 46, max: 53 };

/**
 * Title with the Cortlex brand pattern on the upper left
 */
export const Title = styled.h1`
  color: ${({ theme }) => theme.text};
  font-weight: 700;
  line-height: 1.1;
  letter-spacing: -1px;
  z-index: 1;
  position: relative;
  margin: 0;
  margin-bottom: 50px;
  ${media.generateFontSizeCssForMapping(TITLE_FONT_SIZE_MAP)};
  :before {
    display: block;
    content: ' ';
    z-index: -1;
    background-image: url(${BrandPattern});
    width: ${media.getFontSizeCalc({
      ...TITLE_FONT_SIZE_MAP,
      coefficient: 1.1,
    })};
    height: ${media.getFontSizeCalc({
      ...TITLE_FONT_SIZE_MAP,
      coefficient: 1.1,
    })};
    background-size: ${media.getFontSizeCalc({
      ...TITLE_FONT_SIZE_MAP,
      coefficient: 1.1,
    })};
    background-repeat: no-repeat;
    position: relative;
    top: ${media.getFontSizeCalc({ ...TITLE_FONT_SIZE_MAP, coefficient: 0.8 })};
    left: ${media.getFontSizeCalc({
      ...TITLE_FONT_SIZE_MAP,
      coefficient: -0.4,
    })};
  }
`;

export const InnerRight = styled.div`
  position: relative;
  width: ${({ theme }) => (theme.name == 'cortlex' ? '50%' : '0%')};
  height: 100vh;
  ${media.mediaQueries.mobile`
  width: 0%;
  `}
`;

export const InnerRightImageHolder = styled.div`
  height: 100%;
  position: fixed;
  width: inherit;
`;

export const InnerRightImage = styled.img`
  object-fit: cover;
  height: 100%;
  width: 100%;
  position: relative;
`;

export const InnerFormHolderBottom = styled.div`
  position: relative;
  align-items: center;

  > :nth-child(1) {
    display: inline-block;
    height: calc(20px + 25px);
    > :nth-child(1) {
      ${media.centerVertical}
    }
  }

  > :nth-child(2) {
    float: right;
    margin-left: ${typography.size.xxs};
  }
`;

export const OptionText = styled.div`
  align-items: center;
  display: block;
  ${typography.font.medium};
  font-size: ${typography.size.md};
  line-height: ${typography.size.lg};
  color: ${({ theme }) => theme.text};
`;
